import React from 'react';
import { useLocation } from 'react-router-dom';
import { linkTabs } from '../tabHref';
import { ANALYTICS_TABS, resolveAnalyticsTabId } from './analyticsTabsMeta';

/**
 * Analytics shell state: which tab the URL selects, and nothing else.
 *
 * As thin as `useConfigurationsPage` and for the same reason — the shell holds
 * no range of its own yet. Both tabs are empty pages; when one gains a window
 * it reports over, the range belongs here (in the query string, like
 * `useBooksPage`) only if the *other* tab reads the same window. A filter that
 * scopes one tab belongs to that tab.
 */
export const useAnalyticsPage = () => {
    const { pathname } = useLocation();

    const selectedTabId = resolveAnalyticsTabId(pathname);

    const tabs = React.useMemo(() => linkTabs(ANALYTICS_TABS), []);

    return {
        tabs,
        selectedTabId,
    };
};
